import ObjectEditor from '../object-editor'

import renderForm from './action-base.pug'
import renderFullChrome from './action-full.pug'

export default class ActionBase extends ObjectEditor
  @i18nScope = "editor.actions.base"
  @i18nScopeNamespace = "editor.actions"

  renderForm: renderForm
  renderFullFields: null
  renderFullChrome: renderFullChrome

  @property "fullBreadcrumbItems", get: ->
    [
      @sceneEditor.scene._name || @sceneEditor.t('.scene_name_placeholder')
      @editor?.breadcrumbLabel
      @constructor.label || @constructor.type
    ].filter (item)-> item

  renderLocals: =>
    Object.assign(super(), actionBaseT: ActionBase.t.bind(ActionBase))

  openFull: => @sceneEditor.showFullActionEditor(this)
  closeFull: => @sceneEditor.dismissFullActionEditor()

  renderFull: =>
    @renderTemplate(@renderFullChrome, form: @buildForm(@renderFullFields))
